export default "__VITE_ASSET__DBWVm_Zo__"